import React from "react";
import { graphql } from "gatsby";
import RichText from "./rich-text";
import PhotoTitleText from "./photo-title-text";
import RichTextCols from "./rich-text-cols";
import PhotoBlock from "./photo-block";
import HorizontalRuler from "./horizontal-ruler";
import VideoEmbed from "./video-embed";
import ZooQuaria from "./Zooquaria";
import EventsGroup from "./eventsGroup";
import NewsGroup from "./newsGroup";
import SocialShare from "./SocailFeed";
import MembersMap from "./MembersMap";
import TextPhotoButton from "./TextPhotoButton";
import VideoModal from "./VideoModal";
import LogoCarousal from "./logo-carousal";
import FullWidthPhoto from "./full-width-photo";
import Button from "./button";
const componentsMap = {
  STRAPI__COMPONENT_GENERAL_RICH_TEXT: RichText,
  STRAPI__COMPONENT_GENERAL_TEXT_PHOTO_BUTTON: TextPhotoButton,
  STRAPI__COMPONENT_GENERAL_PHOTO_TITLE_TEXT: PhotoTitleText,
  STRAPI__COMPONENT_GENERAL_RICH_TEXT_COLS: RichTextCols,
  STRAPI__COMPONENT_GENERAL_PHOTO_BLOCK_GROUP: PhotoBlock,
  STRAPI__COMPONENT_GENERAL_HORIZONTAL_RULER: HorizontalRuler,
  STRAPI__COMPONENT_GENERAL_VIDEO_EMBED: VideoEmbed,
  STRAPI__COMPONENT_GENERAL_ZOOQUARIA_GROUP: ZooQuaria,
  STRAPI__COMPONENT_GENERAL_EVENT_GROUP: EventsGroup,
  STRAPI__COMPONENT_GENERAL_NEWS_GROUP: NewsGroup,
  STRAPI__COMPONENT_GENERAL_SOCIAL_FEED: SocialShare,
  STRAPI__COMPONENT_GENERAL_MEMBERS_MAP: MembersMap,
  STRAPI__COMPONENT_GENERAL_VIDEO_MODAL: VideoModal,
  STRAPI__COMPONENT_GENERAL_LOGO_CAROUSEL: LogoCarousal,
  STRAPI__COMPONENT_GENERAL_PHOTO_FULL_WIDTH: FullWidthPhoto,
  STRAPI__COMPONENT_GENERAL_BUTTON: Button,
};

const Block = ({ block }) => {
  const Component = componentsMap[block.__typename];

  if (!Component) {
    return null;
  }

  return <Component data={block} />;
};

const BlocksRenderer = ({ blocks }) => {
  return (
    <div>
      {blocks.map((block, index) => (
        <Block key={`${index}${block.__typename}`} block={block} />
      ))}
    </div>
  );
};

export const query = graphql`
  fragment Blocks on STRAPI__COMPONENT_GENERAL_BUTTONSTRAPI__COMPONENT_GENERAL_EVENT_GROUPSTRAPI__COMPONENT_GENERAL_HORIZONTAL_RULERSTRAPI__COMPONENT_GENERAL_LOGO_CAROUSELSTRAPI__COMPONENT_GENERAL_MEMBERS_MAPSTRAPI__COMPONENT_GENERAL_NEWS_GROUPSTRAPI__COMPONENT_GENERAL_PHOTO_BLOCK_GROUPSTRAPI__COMPONENT_GENERAL_PHOTO_FULL_WIDTHSTRAPI__COMPONENT_GENERAL_PHOTO_TITLE_TEXTSTRAPI__COMPONENT_GENERAL_RICH_TEXTSTRAPI__COMPONENT_GENERAL_RICH_TEXT_COLSSTRAPI__COMPONENT_GENERAL_SOCIAL_FEEDSTRAPI__COMPONENT_GENERAL_TEXT_PHOTO_BUTTONSTRAPI__COMPONENT_GENERAL_VIDEO_EMBEDSTRAPI__COMPONENT_GENERAL_VIDEO_MODALSTRAPI__COMPONENT_GENERAL_ZOOQUARIA_GROUPUnion {
    __typename
    ... on STRAPI__COMPONENT_GENERAL_HORIZONTAL_RULER {
      HorizontalRuler
    }
    ... on STRAPI__COMPONENT_GENERAL_RICH_TEXT {
      TextAlignmentLeft
      RichText {
        data {
          RichText
        }
      }
      Button {
        Label
        Link
        ShowButton
        OpenNewTab
      }
    }
    ... on STRAPI__COMPONENT_GENERAL_BUTTON {
      Label
      Link
      OpenNewTab
      ShowButton
    }
    ... on STRAPI__COMPONENT_GENERAL_PHOTO_FULL_WIDTH {
      id
      Photo {
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    ... on STRAPI__COMPONENT_GENERAL_LOGO_CAROUSEL {
      id
      LogoCarousel {
        Logo {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 200)
            }
          }
        }
        Link
        OpenSameTab
      }
    }
    ... on STRAPI__COMPONENT_GENERAL_VIDEO_MODAL {
      id
      Title
      PlainText
      Media {
        url
      }
      Button {
        Label
        Link
        ShowButton
        OpenNewTab
      }
    }
    ... on STRAPI__COMPONENT_GENERAL_TEXT_PHOTO_BUTTON {
      id
      SubTitleH3
      TitleH2
      PhotoLeft
      RichText {
        data {
          RichText
        }
      }
      Photo {
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      Button {
        Label
        Link
        ShowButton
        OpenNewTab
      }
    }
    ... on STRAPI__COMPONENT_GENERAL_PHOTO_TITLE_TEXT {
      id
      TitleH2
      Text {
        data {
          Text
        }
      }
      Button {
        Label
        Link
        ShowButton
        OpenNewTab
      }
      Photo {
        localFile {
          childImageSharp {
            gatsbyImageData(
              width: 500
              height: 500
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
            )
          }
        }
      }
    }
    ... on STRAPI__COMPONENT_GENERAL_RICH_TEXT_COLS {
      id
      RichTextLeftCol {
        data {
          RichTextLeftCol
        }
      }
      RichTextRightCol {
        data {
          RichTextRightCol
        }
      }

      TitleH2
      SubTitleH3
      TextAlignmentLeft
    }
    ... on STRAPI__COMPONENT_GENERAL_PHOTO_BLOCK_GROUP {
      PhotoBlockGroup {
        PhotoBlock {
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 500
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
    }
    ... on STRAPI__COMPONENT_GENERAL_EVENT_GROUP {
      EventsTeaserIntroText
      EventsTeaserTitle
      EventTeasers {
        id
        events_teaser {
          EventTeaserEndDate
          EventTeaserStartDate
          EventTeaserSummary {
            data {
              EventTeaserSummary
            }
          }
          EventTeaserTitle
          events_article {
            slug
            Hero {
              Media {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
        }
      }
    }
    ... on STRAPI__COMPONENT_GENERAL_VIDEO_EMBED {
      id
      EmbedLink
    }
    ... on STRAPI__COMPONENT_GENERAL_ZOOQUARIA_GROUP {
      id
      ZooquariaGroup {
        Title
        FeaturedText
        Volume
        Date
        Featured
        Url
        Cover {
          largeimage: localFile {
            childImageSharp {
              gatsbyImageData(
                width: 500
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
          smallimage: localFile {
            childImageSharp {
              gatsbyImageData(
                width: 200
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
        PDF {
          localFile {
            url
          }
        }
      }
    }
    ... on STRAPI__COMPONENT_GENERAL_NEWS_GROUP {
      NewsTeaserIntroText
      NewsTeaserTitle
      NewsTeaserGroup {
        news_teaser {
          NewsTeaserImage {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 600
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
          NewsTeaserDate
          NewsTeaserSummary {
            data {
              NewsTeaserSummary
            }
          }
          NewsTeaserTitle
          news_article {
            Slug
            Hero {
              Media {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
        }
      }
    }
    ... on STRAPI__COMPONENT_GENERAL_SOCIAL_FEED {
      SocialTitle
      SocialUrl
    }
    ... on STRAPI__COMPONENT_GENERAL_MEMBERS_MAP {
      Title
      Button {
        Label
        Link
        ShowButton
        OpenNewTab
      }
      members {
        Country
        Lattitude
        Longitude
        MemberCategory
        Membership
        OrganisationName
        Postcode
        WebsiteUrl
        MemberLogo {
          url
        }
      }
    }
  }
`;

export default BlocksRenderer;
